import { render, staticRenderFns } from "./custimizeIframe.vue?vue&type=template&id=7ca2eb08&scoped=true"
import script from "./custimizeIframe.vue?vue&type=script&lang=js"
export * from "./custimizeIframe.vue?vue&type=script&lang=js"
import style0 from "./custimizeIframe.vue?vue&type=style&index=0&id=7ca2eb08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2eb08",
  null
  
)

export default component.exports